import "../../modal.scss";
import React, { useState, useEffect, useRef, useContext } from "react";
import Modal from "react-modal";
import { Datatable } from "../clientesTable/Datatable";
import { ClientesState } from "../../../context/clientes/ClientesState";
import { DarkModeContext } from "../../../context/darkModeContext";

Modal.setAppElement("#root"); // Necesario para accesibilidad

const ClientesModal = ({ handleChange, handleDescChange, descSelected }) => {
  const { darkMode } = useContext(DarkModeContext);
  const name = "Clientes";
  const [searchIdItem, setSearchIdItem] = useState("");
  const [searchDescItem, setSearchDescItem] = useState(""); // Descripción seleccionada
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Sincronizar descSelected inicial con el estado
  useEffect(() => {
    if (descSelected && searchDescItem !== descSelected) {
      setSearchIdItem(0);
      setSearchDescItem(descSelected);
    } else if (!descSelected && searchDescItem !== "") {
      setSearchDescItem("");
    }
  }, [descSelected]);

  const handleRowClick = (selectedId, selectedDesc) => {
    setSearchIdItem(selectedId);
    setSearchDescItem(selectedDesc);
    handleChange(selectedId);
    handleDescChange(selectedDesc);
    setIsModalOpen(false);
  };

  const handleClear = () => {
    setSearchIdItem(null);
    setSearchDescItem("");
    handleChange(null);
    handleDescChange("");
    if (searchInputRef.current) {
      searchInputRef.current.value = `Buscar ${name}`;
    }
  };

  return (
    <> <div className={`inputWrapper ${darkMode ? 'dark' : ''}`}>
      <input
        type="text"
        value={searchDescItem || "Buscar " + name}
        readOnly
        ref={searchInputRef}
      />
      {!searchIdItem && !searchDescItem && (
        <button
          className="SearchButton"
          onClick={(e) => {
            e.preventDefault();
            setIsModalOpen(true);
          }}
        >
          🔍
        </button>
      )}
      {(searchIdItem || searchDescItem) && (
        <button
          className="clearButton"
          onClick={(e) => {
            e.preventDefault();
            handleClear();
          }}
        >
          ❌
        </button>
      )}
    </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Seleccionar"
        className={`modal ${darkMode ? "dark" : ""}`}
        overlayClassName={`overlay ${darkMode ? "dark" : ""}`}
      >
        <div className="data-grid-container">
          <div
            className="datatable"
            style={{
              height: "100%",
              maxHeight: "calc(80vh - 60px)",
              overflowY: "auto",
            }}
          >
            <ClientesState>
              <Datatable
                onSelect={handleRowClick}
                onClose={() => setIsModalOpen(false)}
                enableCreate={false}
              />
            </ClientesState>
          </div>
        </div>
        <button
          className="modalCloseButton"
          onClick={() => setIsModalOpen(false)}
        >
          ❌
        </button>
      </Modal>
    </>
  );
};

export default ClientesModal;
